import { usePaginatedSearch } from '../usePaginatedSearch';
import { getAdminContentList } from '@/services/api/requests/content';
import queryKeys from '@/constants/queryKeys';
import { TSortingDirection } from '@/types';
import {
  TContentListItem,
  TContentStatusFilter,
  TContentType,
  TContentVisibilityFilter,
} from '@/types/Content.types';

const useAdminContentList = ({
  filterText,
  status,
  type,
  visibility,
  isPlatformContent,
  sortBy,
  sortDir,
}: {
  filterText: string;
  status: TContentStatusFilter;
  type?: TContentType;
  visibility?: TContentVisibilityFilter;
  isPlatformContent?: boolean;
  sortBy: string;
  sortDir: TSortingDirection;
}) => {
  return usePaginatedSearch<TContentListItem[], string, string>({
    query: (page, _searchFilterType, searchFilterText, sortingColumn, sortingDirection) =>
      getAdminContentList({
        page,
        filterText: searchFilterText,
        status,
        type,
        visibility,
        isPlatformContent,
        sort: sortingColumn && sortingDirection ? `${sortingColumn}:${sortingDirection}` : undefined,
      }),
    queryKey: [
      queryKeys.content.all,
      status,
      type ?? 'all',
      visibility ?? 'all',
      String(isPlatformContent ?? 'any'),
    ],
    // Composite so changing any filter resets pagination to page 1.
    searchFilterType: `${status}|${type ?? 'all'}|${visibility ?? 'all'}`,
    searchFilterText: filterText,
    sortingColumn: sortBy,
    sortingDirection: sortDir,
  });
};

export default useAdminContentList;
